module.exports = __webpack_public_path__ + "static/media/add-storage.8b6db70e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/gifs/add-storage.gif
// module id = 2367
// module chunks = 0